window.onload = function () {
  const overlay = document.getElementById("overlay");
  const modal = document.getElementById("modal");

  // Modal
  if (document.querySelector("#btn-modal") != null) {
    document
      .querySelector("#btn-modal")
      .addEventListener("click", function () {
        overlay.classList.add("is-visible");
        modal.classList.add("is-visible");
      });
  }

  document.getElementById("close-btn").addEventListener("click", function() {
    overlay.classList.remove("is-visible");
    modal.classList.remove("is-visible");
  });

  overlay.addEventListener("click", function() {
    overlay.classList.remove("is-visible");
    modal.classList.remove("is-visible");
  });

  // Tab selector line
  const option2 = document.querySelector(".option-2");
  const content2 = document.querySelector(".option-2-content");
  const option1 = document.querySelector(".option-1");
  const content1 = document.querySelector(".option-1-content");
  const select = document.querySelector(".selected-item");

  if (option2 && content2 && select) {
    option2.addEventListener("click", function () {
      select.classList.add("second-selected");
      content2.classList.add("is-visible");
      content1.classList.remove("is-visible");
    });
    console.log("Missing");
  }

  if (option1 && content1) {
    option1.addEventListener("click", function () {
      select.classList.remove("second-selected");
      content1.classList.add("is-visible");
      content2.classList.remove("is-visible");
    });
  }
};
